import * as React from "react";
import { checkboxColumns, tableItems } from "./TableData";
import { ListSelection } from "azure-devops-ui/List";
import { Card } from "azure-devops-ui/Card";
import { Table } from "azure-devops-ui/Table";

export default class TableCheckboxExample extends React.Component {
    private selection = new ListSelection({ selectOnFocus: false, multiSelect: true });

    public render(): JSX.Element {
        return (
            <Card className="flex-grow bolt-table-card" contentProps={{ contentPadding: false }}>
                <Table
                    ariaLabel="Table with checkboxes"
                    className="table-example"
                    columns={checkboxColumns}
                    containerClassName="h-scroll-auto"
                    itemProvider={tableItems}
                    selection={this.selection}
                    role="table"
                />
            </Card>
        );
    }
}
